import { APICall } from "../service"

const ControllerName = "Government"

export const GetGovernmentLookup = (lang) => {
    return APICall("get", ControllerName + "/lookup", {}, lang)
}